<template>
  <svg
    version="1.1"
    id="レイヤー_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve"
  >
    <g id="グループ_372" transform="translate(0.999 1)">
      <path
        id="パス_36"
        :style="{
          stroke: colors[0],
        }"
        class="st0"
        d="M1.4,11v9.9h20V11"
      />
      <path
        id="パス_37"
        :style="{
          stroke: colors[0],
        }"
        class="st1"
        d="M11.4,1.8v13.9"
      />
      <path
        id="パス_38"
        :style="{
          stroke: colors[0],
        }"
        class="st1"
        d="M6.5,10.8l4.9,4.9l4.9-4.9"
      />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'download',
    props: {
      size: {
        type: Number,
        default: 20,
      },
      colors: {
        type: Array,
        default: () => ['#6F6F6F'],
      },
    },
  };
</script>
<style scoped>
  .st0 {
    fill: none;
    stroke-width: 2.7834;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .st1 {
    fill: none;
    stroke-width: 2.7834;
    stroke-linecap: round;
  }
</style>
